export default __webpack_public_path__ + "46f550d1b7b0a52619ae9564e98ea0b6.png";